import React from 'react';

import { Stack, Group, Text } from '@mantine/core';
import DownloadButton from '@/components/DownloadButton';
import { IEventDownloadDetails } from '../types';
import { IconDownload } from '@tabler/icons-react';
import TablerIconDynamic from '@/components/TablerIconDynamic';

export const EventDownload: React.FC<{
  eventDownloadDetails: IEventDownloadDetails;
}> = ({ eventDownloadDetails }) => {
  const {
    sectionLabel,
    leftButtonLabel,
    leftDownloadUrl,
    leftIcon,
    rightIcon,
    rightButtonLabel,
    rightDownloadUrl,
    rightSectionIcon,
  } = eventDownloadDetails;
  return (
    <Stack gap="xs">
      <Text>{sectionLabel}:</Text>
      <Group gap="xs" grow>
        <DownloadButton
          label={leftButtonLabel}
          href={leftDownloadUrl}
          leftSectionIcon={<TablerIconDynamic icon={leftIcon} size={18} />}
          rightSectionIcon={rightSectionIcon && <IconDownload size={16} />}
        />
        <DownloadButton
          label={rightButtonLabel}
          href={rightDownloadUrl}
          leftSectionIcon={<TablerIconDynamic icon={rightIcon} size={18} />}
          rightSectionIcon={rightSectionIcon && <IconDownload size={16} />}
        />
      </Group>
    </Stack>
  );
};
